export default __webpack_public_path__ + "static/live-hero-four-right-dea14a2f6d0885f11441591a6329a1a9.webp";